"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculatePNG = exports.isPNG = void 0;
var pngSignature = 'PNG\r\n\x1a\n';
var pngImageHeaderChunkName = 'IHDR';
var pngFriedChunkName = 'CgBI';

function isPNG(buffer) {
  if (pngSignature === buffer.toString('ascii', 1, 8)) {
    var chunkName = buffer.toString('ascii', 12, 16);

    if (chunkName === pngFriedChunkName) {
      chunkName = buffer.toString('ascii', 28, 32);
    }

    if (chunkName !== pngImageHeaderChunkName) {
      throw new TypeError('invalid png');
    }

    return true;
  }
}

exports.isPNG = isPNG;

function calculatePNG(buffer) {
  if (buffer.toString('ascii', 12, 16) === pngFriedChunkName) {
    return {
      width: buffer.readUInt32BE(32),
      height: buffer.readUInt32BE(36)
    };
  }

  return {
    width: buffer.readUInt32BE(16),
    height: buffer.readUInt32BE(20)
  };
}

exports.calculatePNG = calculatePNG;